<formly-form
    [form]="refForm"
    [fields]="fields"
    [model]="model"
    (modelChange)="onModelChanged($event)"
></formly-form>
